import { Controller } from "@hotwired/stimulus"

const START_EVENT = "interface-tour:start"

/** Starts the cabinet tour from any page (settings, navbar). */
export default class extends Controller {
  start(event) {
    event.preventDefault()
    document.dispatchEvent(new CustomEvent(START_EVENT))
  }
}
